<template>
  <div>
    <div class="twitter-post-preview-body-advanced__head">
      <div v-if="msg" class="twitter-post-preview-body-advanced__message" v-html="msg"></div>
      <a
        v-if="link"
        :href="link"
        target="_blank"
        class="twitter-post-preview-body-advanced__link"
      >
        {{ link }}
      </a>
    </div>
    <div v-if="image" class="twitter-post-preview-body-advanced__wrapper">
      <shared-social-post-preview-image
      v-if="image"
      title="Post Image Preview"
      :image="image"
    />
    </div>     
  </div>
</template>

<script>
import TwitterPostPreviewBodyAdvancedHead from './TwitterPostPreviewBodyAdvancedHead.vue';
import SharedSocialPostPreviewImage from '../../shared/SharedSocialPostPreviewImage';
import {extractSocialPostStepPieces} from '../../../mixins/extractSocialPostStepPieces.mixin';

export default {
  mixins: [extractSocialPostStepPieces],
  components: {
    TwitterPostPreviewBodyAdvancedHead,
    SharedSocialPostPreviewImage
  },
  props: {
    pieces: Array,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../../sass/web/_variables';
.twitter-post-preview-body-advanced {
  &__head {
     min-height: 20px;
  }
  &__message,
  &__link {
    padding-bottom: 5px;
    font-size: 14px;
  }
  &__link {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #299ded;
    max-width: 360px;
  }
  &__wrapper:not(:empty) {
    border: 1px solid rgba($black-color, 0.2);
    border-radius: 19px;
    overflow: hidden;
  }
  &__img {
    width: 100%;
  }
}
</style>
